/* eslint-disable max-len */

export const EN_CONTENT = {
	consentModal: {
		title:
			"Giving You The Best Experience",
		description: `We use cookies and similar technologies to personalise content, analyse website performance and tailor and measure ads. `,
		showPreferencesBtn: "Manage cookies",
		acceptAllBtn: "Accept all",
	},
	preferencesModal: {
		title: `
		<div class="flex flex-col items-start gap-2">
		<h3 class="font-normal md:h2-xs">Manage Cookies</h3>
		<p class="text-sm">Learn more about what each cookie category does and choose your settings.</p>
		</div>
		`,
		savePreferencesBtn: "SAVE PREFERENCES",
		closeIconLabel: "Close",
		sections: [
			{
				title: "Essential Cookies <span class=\"pm__badge\">Always Active</span>",
				description:
					"Essential cookies are required for the MOD Lighting website and app to function correctly. These cookies are automatically enabled, as without essential cookies some site functionality may not work and you may be unable to place an order.",
				linkedCategory: "necessary",
			},
			{
				title: "Analytics Cookies",
				description:
					"Analytics cookies help us to understand how customers use our website and app and their shopping behaviors. This allows us to group those with similar behaviours into segments, ultimately helping us to develop ways to improve our platforms and your shopping experience.",
				linkedCategory: "analytics_storage",
			},
			{
				title: "Affiliate Cookies",
				description:
					"Affiliate cookies are used by us to understand and measure sales from affiliate partners. Affiliates are companies who promote Selfridges and our products on third-party sites and link through to our website.",
				linkedCategory: "ad_storage",
			},
			{
				title: "Internet Advertising Cookies",
				description:
					"We use internet advertising cookies to measure the effectiveness of our advertising, by understanding which advertising you click on and interact with, as well as your shopping behaviours on our website and app. We may then use this to create user profiles and group those with similar behaviours into segments, helping us to improve the relevance of our advertising.",
				linkedCategory: "ad_personalization",
			},
			{
				title: "Social Cookies",
				description:
					"Social cookies allow us to include social sharing functionalities on our website and app (e.g. the ‘Like’ button). Social cookies are also used to measure the effectiveness of any advertising we do across social networks.",
				linkedCategory: "ad_user_data",
			}
		],
	},
};